import { DATE_FORMAT } from 'constants/formats'
import { formatDate } from '@the-platform-group/formatters/dateFormat'
import { formatDateTimeToLocalDate } from 'utils/format'

/**
 * Transform form data to request payload format
 * @param {object} formData - form data from react-hook-form
 * @returns {object} formatted request data
 */
export const transformFormDataToRequestPayload = formData => {
  return {
    customerId: formData.customerName?.id,
    requestedBy: formData.requestedBy?.value,
    securityId: formData.security?.id,
    name: formData.requestName,
    message: formData.description,
    requestDate: formData.requestDate ? formatDate(formData.requestDate, DATE_FORMAT) : null,
    urls: formData.urls || [],
  }
}

/**
 * Transform request data to form values format
 * @param {object} request - request data from API
 * @returns {object} formatted form values
 */
export const transformRequestToFormValues = request => {
  return {
    customerName: request.customer
      ? {
          id: request.customer.id,
          label: request.customer.name,
          value: request.customer.id,
          secondaryText: request.customer?.type ? `Account type: ${request.customer.type}` : '',
        }
      : null,
    requestedBy: request.user
      ? {
          label: `${request.user.firstName} ${request.user.lastName}`,
          value: request.user.id,
        }
      : null,
    requestDate: request.requestedAt ? formatDateTimeToLocalDate(request.requestedAt) : null,
    security: request.security || null,
    requestName: request.name || '',
    description: request.message || '',
    urls: request.urls || [],
  }
}

/**
 * Default form values for request forms
 */
export const DEFAULT_CREATE_AND_EDIT_FORM_VALUES = {
  customerName: null,
  requestedBy: null,
  requestDate: null,
  security: null,
  requestName: '',
  description: '',
  urls: [],
}

/**
 * Invalidate queries after successful form submission
 * @param {object} queryClient - react-query client instance
 */
export const invalidateRequestQueries = queryClient => {
  queryClient.invalidateQueries({ queryKey: ['requests'] })
  queryClient.invalidateQueries({ queryKey: ['useUploadRequestsQuery'] })
}
